import * as hookFormDevTools from "@hookform/devtools";

const showDevTools = process.env.NODE_ENV === "development";

export const DevTool: (typeof hookFormDevTools)["DevTool"] = showDevTools
  ? hookFormDevTools.DevTool
  : function () {
      return null;
    };
